import type { FC } from 'react';
import { useReducer } from 'react';
import type { IContainerChildrenProps } from 'utils';
import { EndpointContext } from './EndpointContext';
import { EndpointReducer } from './EndpointReducer';

const EndpointProvider: FC<IContainerChildrenProps> = ({ children }) => {
  const [state, dispatch] = useReducer(EndpointReducer, { schema: {}, service: { name: '', schema: {} } });

  // eslint-disable-next-line react/jsx-no-constructed-context-values
  return <EndpointContext.Provider value={{ state, dispatch }}>{children}</EndpointContext.Provider>;
};

export default EndpointProvider;
